/**
 * SecureEmbed Energy Portal - ChartCard Component
 */

import React from 'react';
import InfoTooltip from './InfoTooltip';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  tooltipId?: string;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, subtitle, children, action, tooltipId }) => {
  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-1.5">
            {title}
            {tooltipId && <InfoTooltip tooltipId={tooltipId} />}
          </h3>
          {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
};

export default ChartCard;
